class CartRemoveButton extends HTMLElement {
 
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
       
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
     
      //new pj code
      let closestRow = this.closest("tr"); // Find the closest <tr> element
      if (closestRow) {
        var variantId = closestRow.getAttribute("data-itemid"); // Get the data-itemid attribute
        if(variantId==null){
          var variantId = closestRow.getAttribute("data-itemid-free") //for free item delete
        }
       
       var name='';
        //return dataItemId; // Return the value
      } else {
          //console.log("No parent <tr> with data-itemid found.");
          var variantId = null;
          var name='';
          
      }
    
      let removeButtonContainer = this.closest(".cart-remove-button-container");
      if (removeButtonContainer) {
        
            let cartStatus=false;
            let deletStatus = false;  //delete click from main cart
            let containerId = removeButtonContainer.id;
            //console.log(`Clicked remove button in container with ID: ${containerId}`);
           // alert(variantId);
           // if(window.location.href=="https://raf-pharmacy.myshopify.com/cart"){
            if( window.location.pathname=="/cart" || window.location.pathname=='/ar/cart'){
                cartStatus=true; //if try to delete from main cart page
                 if(variantId==null){
                   deletStatus = true; //delete click from mini cart
                 }
              }
            if (containerId.includes("-free")) { //will work when free items remove from cart
              if(variantId==null){
                var variantId = removeButtonContainer.getAttribute("data-varid");
              }else{
                //cartStatus=true; //if try to delete from main cart page
              }
              
               let trId;
           // alert(cartStatus);
            // alert(variantId);
             // alert("containerId "+containerId); 
              const className = `remove-${variantId}`;
              const tr = document.querySelector(`tr.${className}`);
               document.querySelectorAll(`tr.remove-${variantId}`).forEach(tr => tr.remove());
             // return false;
             /* if(cartStatus==true){
                if(deletStatus==true){ //delete click from mini cart
                 trId = containerId.replace("Remove","Item");
                 var tabletrId = document.getElementById(trId);
                 tabletrId.remove(); //remove free item tr from mini cart
                 trId = containerId.replace("CartDrawer-Remove","CartItem");
                 //alert("trId "+trId); 
               // Item-1-free-40758134374435
                //CartDrawer-Item-1-free-40758134374435
                   var tabletrId = document.getElementById(trId);
                  tabletrId.remove(); //remove free item tr from main cart
                }else{
                  //if delete click from main cart below code will work
                  //delete main cart tr
                   trId = containerId.replace("Remove","CartItem");
                  //alert("trId "+trId); 
                  var tabletrId = document.getElementById(trId);
                   tabletrId.remove();

                  //delete from mini cart
                   trId = containerId.replace("Remove","CartDrawer-Item");
                  
                   var tabletrId = document.getElementById(trId);
                   tabletrId.remove();
                }
              }else{
                trId = containerId.replace("Remove","Item"); //find out id of tr need to remove
                var tabletrId = document.getElementById(trId);
                tabletrId.remove(); //remove free item tr

                //trId = containerId.replace("CartDrawer-Remove","CartItem"); //find out id of tr need to remove
                 // alert(trId);
                //var tabletrId = document.getElementById(trId);
                //tabletrId.remove(); //remove free item tr
              } */
              //console.log("Cart items");
              //console.log(cartItems);
             // console.log("End Cart items");
              //alert(variantId);
              removeFreeItemsDirectly(variantId);
              
              return false;
              
            }
        }
      //end 
      //cartItems.updateQuantity(this.dataset.index, 0); //original
    
      cartItems.updateQuantity(this.dataset.index, 0,name,variantId); //new added by pj
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {

   checkForControlMedicineInCart();
    
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          //pj code
          showFreeItemsInCart();
              //end
        })
        .catch((e) => {
          //console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          //console.error(e);
        });
    }

  
    
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-ftr',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
   //alert('Update qty');
   //alert(quantity);
   //new code by pj
    var freeItemsstats = manageFreeItemsQtyIncrement(line,quantity,variantId,name); //function wrote inside bogo-offer-rule.js
    if(freeItemsstats==true){
      return;
    }

    //end code
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
     
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        //new code pj
        
        showFreeItemsInCart();  //show free items in cart
        
            


        
       // console.log("after added cart items: ",cartData);
        //end code
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


/* New Code From shalini */
//Fetch prescription for tag
function fetchAndStoreData222222() {
  let customerId = ShopifyAnalytics.meta.page.customerId;
  alert(customerId);
  if (customerId) {
    const fetchUrl = `https://app.rafpharmacy.com/api/prescription/get?customer_id=${encodeURIComponent(
      customerId
    )}`;
    try {
      fetch(fetchUrl)
        .then((response) => response.json())
        .then((data) => {
          // Store the data in localStorage
          localStorage.setItem(`prescriptions_${customerId}`, JSON.stringify(data));
          //localStorage.setItem("prescriptions", JSON.stringify(data));
        })
        .catch((error) => {
          //console.error("Error fetching uploaded files:", error); // prescriptionsContainer.innerHTML = "<p> You haven't uploaded any prescriptions yet. </p>";
        });
      setTimeout(() => {
        renderDataPrescription();
      }, 1000);
    } catch (error) {
      // Catch any other errors that might occur
      //console.error("Unexpected error:", error);
    }
  }
}

function fetchAndStoreData() {
  let customerId = ShopifyAnalytics.meta.page.customerId;
  if (customerId) {
    const fetchUrl = `https://app.rafpharmacy.com/api/prescription/get?customer_id=${encodeURIComponent(customerId)}`;

    fetch(fetchUrl)
      .then((response) => {
        if (!response.ok) {
          //throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Check if response has a body
        return response.text().then((text) => {
          if (!text) {
            return null; // No content
          }
          return JSON.parse(text); // Parse manually to avoid .json() crash
        });
      })
      .then((data) => {
        if (data) {
          localStorage.setItem(`prescriptions_${customerId}`, JSON.stringify(data));
        } else {
          //console.log("No prescription data found.");
        }

        setTimeout(() => {
          renderDataPrescription();
        }, 1000);
      })
      .catch((error) => {
        //console.error("Error fetching uploaded files:", error);
      });
  }
}


function checkForControlMedicineInCart() {
  const cartItems = document.querySelectorAll(".product-tags");
  let hasControlMedicine = false;
  let customerId = ShopifyAnalytics.meta.page.customerId;

  cartItems.forEach((item) => {
    if (item.classList.contains("control-medicine")) {
      hasControlMedicine = true;
    }
  });

  if (hasControlMedicine) {
    //console.log("Control Medicine found in cart. Fetching store data...");
    if (customerId) {
      fetchAndStoreData();
      /* For Control Medicine tag.*/
      setTimeout(() => {
        const dropdown = document.querySelector("#prescription-dropdown"); // Select the dropdown
        if (dropdown) {
          const savedValue = localStorage.getItem(
            `prescription-dropdown-${dropdown.dataset.itemKey}`
          ); // Get saved value

          if (savedValue) {
            const options = dropdown.querySelectorAll("option"); // Get all options
            options.forEach((option) => {
              if (option.value === savedValue) {
                option.selected = true; // Explicitly set the selected option
              } else {
                option.selected = false; // Unselect other options
              }
            });

            let checkoutBtn =
              document.querySelector("#CartDrawer-Checkout") ||
              document.querySelector("#CartDrawer-Checkout-custom");
            if (checkoutBtn) {
              delete checkoutBtn.dataset.listenerAdded;
              //checkoutBtn.removeAttribute("disabled");
            } //Button enabled
          }
        }
      }, 1000);
      setTimeout(() => {
        attachCheckoutListener();

        //     // Re-fetch dropdown before dispatching change event
        //     // const dropdown = document.querySelector("#prescription-dropdown");
        //     // if (dropdown) {
        //     //   const event = new Event("change");
        //     //   dropdown.dispatchEvent(event);
        //     // }
      }, 500);
    }
    // Attach event listener to Checkout button (if not already attached)
    //  const checkoutBtn = document.querySelector('.cart__checkout-button-custom') || document.querySelector('.cart__checkout-button');
  }
}

function attachCheckoutListener() {
  let checkoutBtn =
    document.querySelector("#CartDrawer-Checkout") ||
    document.querySelector("#CartDrawer-Checkout-custom");
  if (checkoutBtn && !checkoutBtn.dataset.listenerAdded) {
    checkoutBtn.addEventListener("click", function (event) {
      // Prevent multiple triggers
      if (!checkoutBtn.classList.contains("proceeding")) {
        checkoutBtn.classList.add("proceeding");
      }

      // Check if the prescription dropdown exists
      let prescriptionDropdown = document.querySelector(
        "#prescription-dropdown"
      );
      if (prescriptionDropdown) {
        attachPrescriptionDropdownListeners(); // Call function before checkout
      }
    });

    checkoutBtn.dataset.listenerAdded = "true"; // Prevent duplicate listeners
  }
}

// Call this function to ensure the listener is attached on page load
//document.addEventListener("DOMContentLoaded", attachCheckoutListener);

// Function to retrieve and render data in HTML
function renderDataPrescription() {
  // Determine the currently visible container
  let customerId = ShopifyAnalytics.meta.page.customerId;
  const parentDiv = document.getElementById("parent");
  const modalDiv = document.getElementById("child");
  const visibleContainer =
    parentDiv?.offsetParent !== null && parentDiv?.offsetParent !== undefined
      ? parentDiv
      : modalDiv?.offsetParent !== null && modalDiv?.offsetParent !== undefined
      ? modalDiv
      : null;

  if (visibleContainer) {
    const hiddenInput = visibleContainer.querySelector(
      ".control-medicine_flag"
    );
    const checkoutButton =
      visibleContainer.querySelector(".cart__checkout-button") ||
      visibleContainer.querySelector(".cart__checkout-button-custom");
    if (!hiddenInput) {
     // console.warn("No hidden input found in the visible container");
    } else {
      const controlFlag = hiddenInput.value;
      if (controlFlag === "false" && checkoutButton) {
        checkoutButton.removeAttribute("disabled");
      }
    }
  } else {
    //console.warn("No visible container found");
  } // Load prescriptions data from localStorage
const prescriptionsData = localStorage.getItem(`prescriptions_${customerId}`);
  //const prescriptionsData = localStorage.getItem("prescriptions");
  if (!prescriptionsData) {
    console.warn("No prescriptions data found in localStorage");
    return;
  }

  const prescriptions = JSON.parse(prescriptionsData);
  if (!Array.isArray(prescriptions) || prescriptions.length === 0) {
   // console.error("No prescription data available.");
    return;
  } // Populate all dropdowns with class 'prescription-dropdown'
  const dropdowns = document.querySelectorAll(".prescription-dropdown");

  if (dropdowns.length === 0) {
   // console.error("No dropdowns found.");
    return;
  }
  // else{
  dropdowns.forEach((dropdown) => {
    const controlFlagElement = dropdown
      .closest(".checkout_div")
      ?.querySelector(".control-medicine_flag");
    if (!controlFlagElement || controlFlagElement.value !== "true") return; // Clear existing options

    dropdown.innerHTML = ""; // Create a default "Choose a Prescription" option

    // const defaultOption = document.createElement("option");
    // defaultOption.value = "";
    // defaultOption.textContent = "Select Patient";
    // dropdown.appendChild(defaultOption); // Add prescriptions to the dropdown

const defaultOption = document.createElement("option");
defaultOption.value = "";
defaultOption.textContent = "Select Patient";
defaultOption.selected = true;   // Make sure it's selected
// Do not disable it, so the browser keeps it as the default selection.
dropdown.insertBefore(defaultOption, dropdown.firstChild);
    

    prescriptions.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.id;
      option.textContent = `${item.patient} ${item.date}`;
      dropdown.appendChild(option);
    }); // Add change event listener to enable/disable the checkout button

    const checkoutButton =
      dropdown
        .closest(".checkout_div")
        ?.querySelector(".cart__checkout-button") ||
      dropdown
        .closest(".checkout_div")
        ?.querySelector(".cart__checkout-button-custom");
    if (checkoutButton) {
      dropdown.addEventListener("change", () => {
        if (dropdown.value) {
          const key = dropdown.dataset.itemKey; // Use dataset itemKey to uniquely identify the dropdown
          const selectedValue = dropdown.value;

          // Save selected value to localStorage
          localStorage.setItem(`prescription-dropdown-${key}`, selectedValue);
          checkoutButton.removeAttribute("disabled"); //Button enabled
        } else {
          checkoutButton.setAttribute("disabled", "true");
        }
      });
    }
  });
  //}//else
}



function attachPrescriptionDropdownListeners() {
  const dropdown = document.querySelector("#prescription-dropdown");
  //console.log('Adding prescription note');
  if (dropdown) {
    if (dropdown.value) {
      const prescriptionId = dropdown.value;
      // Fetch prescription details
      fetchPrescriptionDetails(prescriptionId)
        .then((details) => {
          if (details) {
            // Prepare note parts based on available details
            const noteParts = [
              `Prescription ID: ${details.prescriptionId}`,
              details.mainPrescription
                ? `Main Prescription: ${details.mainPrescription}`
                : "",
              details.secondaryPrescription
                ? `Secondary Prescription: ${details.secondaryPrescription}`
                : "",
              details.insuranceCard
                ? `Insurance Card: ${details.insuranceCard}`
                : "",
              details.claimFile ? `Claim File: ${details.claimFile}` : "",
              details.qatarId ? `Qatar ID: ${details.qatarId}` : "",
              details.otherDoc ? `Other Document: ${details.otherDoc}` : "",
              `Patient: ${details.patient}`,
              details.notes ? `Notes: ${details.notes}` : "",
            ].filter(Boolean); // Remove empty items

            // Join parts into a single note string
            const note = noteParts.join(", ");

            // Update the cart note
            updateCartNote(note);
           // console.log(`Cart note updated with: ${note}`);
          } else {
           // console.warn("No details found for the selected prescription");
          }
        })
        .catch((error) => {
         // console.error("Error fetching prescription details:", error);
        });
    } else {
      updateCartNote(""); // Clear cart note if no prescription is selected
     // console.log("Cart note cleared");
    }
  } //);
}

// Function to update the cart note via Shopify API
function updateCartNote(note) {
  // Make an API call to update the cart note in Shopify (or your backend)
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      note: note,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
     // console.log("Cart note updated successfully", data);
    })
    .catch((error) => {
     // console.error("Error updating cart note", error);
    });
}

// Function to fetch detailed prescription information (e.g., file paths) from the API
function fetchPrescriptionDetails(prescriptionId) {
  const customerId = ShopifyAnalytics.meta.page.customerId;
  const apiUrl = `https://app.rafpharmacy.com/api/prescription/get?customer_id=${encodeURIComponent(
    customerId
  )}&prescription_id=${encodeURIComponent(prescriptionId)}`;
  return fetch(apiUrl)
    .then((response) => {
      if (!response.ok) throw new Error("Failed to fetch prescription details");
      return response.json();
    })
    .then((data) => {
    //  console.log("ddd");
      if (Array.isArray(data) && data.length > 0) {
        const pres = data[0]; // Assuming only one prescription detail is needed
        // dropdowns.forEach((dropdown) => {

        return {
          prescriptionId: pres.id,
          mainPrescription: pres.document_grid.Pres1.url || null,
          secondaryPrescription: pres.document_grid.Pres2.url || null,
          insuranceCard: pres.insurance_doc.ic.url || null,
          claimFile: pres.insurance_doc.claim.url || null,
          qatarId: pres.insurance_doc.qatarid.url || null,
          otherDoc: pres.insurance_doc.otherdoc.url || null,
          patient: pres.patient,
          notes: pres.notes,
        };
      }
      throw new Error("No prescription details found");
    })
    .catch((error) => {
     // console.error("Error fetching prescription details:", error);
      return null;
    });
}

// Call the function to fetch and store data initially
//if (window.location.pathname.includes('cart')) {
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onPageLoad);
  //checkForControlMedicineInCart();
} else {
  onPageLoad();
}
//}
function onPageLoad() {
  checkForControlMedicineInCart();
  let checkoutBtn =
    document.querySelector("#CartDrawer-Checkout") ||
    document.querySelector("#CartDrawer-Checkout-custom");
  if (checkoutBtn) delete checkoutBtn.dataset.listenerAdded;
}
